<template>
  <div class="media-container">
    <v-breadcrumbs :items="breadcrumbs" v-if="!isMobile">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-row>
      <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pa-md-0 pa-sm-0 py-0">
        <div class="back">
          <button @click="$router.go(-1)">
            <v-icon>mdi-chevron-left</v-icon>
            {{ chapter }}
          </button>
        </div>
      </v-col>
      <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="pa-md-0 pa-sm-0 py-0">
        <div
          v-if="sectionContent.Media[0].$.type === 'audio'"
          class="title-audio"
        >
          <template>
            <v-icon>mdi-music</v-icon>
            {{ this.section }}
          </template>
        </div>
        <div
          v-if="sectionContent.Media[0].$.type === 'video'"
          class="title-video"
        >
          <template>
            <v-icon large>mdi-play</v-icon>
            {{ this.section }}
          </template>
        </div>
      </v-col>
    </v-row>
    <template v-if="sectionContent.Media[0].$.type === 'audio'">
      <MediaAudio
        :sectionContent="sectionContent"
        :bookTitle="bookTitle"
        :chapter="chapter"
        :section="section"
      />
    </template>
    <template v-if="sectionContent.Media[0].$.type === 'video'">
      <MediaVideo
        :sectionContent="sectionContent"
        :bookTitle="bookTitle"
        :chapter="chapter"
        :section="section"
      />
    </template>
  </div>
</template>

<script lang="js">
import MediaAudio from '@/components/media/MediaAudio'
import MediaVideo from '@/components/media/MediaVideo'
import { mapState } from 'vuex'
export default {
  name: 'Media',
  components: {
    MediaAudio,
    MediaVideo
  },
  props: ['chapter', 'section'],
  beforeMount () {
    if (this.sectionContent.Media[0].$.type === 'audio') {
      this.title = 'Audio'
    } else if (this.sectionContent.Media[0].$.type === 'video') {
      this.title = 'Video'
    }
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  data () {
    return {
      isMobile: false,
      breadcrumbs: [
        {
          text: this.chapter,
          disabled: false,
          href: './',
          divider: '>'
        },
        {
          text: this.section,
          disabled: true,
          href: '#',
          divider: '>'
        }
      ]
    }
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth <= 600
    }
  },
  computed: {
    ...mapState({
      chapterMap: state => state.book.chapterMap,
      chapterHeading: state => state.book.chapterHeading,
      chapterTitle: state => state.book.chapterTitle,
      sectionContent: state => state.book.sectionContent,
      bookTitle: state => state.book.bookTitle
    })
  }
}
</script>

<style lang="scss">
.media-container {
  min-height: auto;
  @media screen and (min-width: 600px) {
    margin: auto;
    width: 90%;
  }
  margin: auto;
  .v-breadcrumbs {
    .v-breadcrumbs__item {
      color: #e6007e;
    }
  }
  .back {
    height: 64px;
    background-color: #ffffff;
    text-align: left;
    font-size: 17px;
    padding: 30px 30px 30px 0;
  }
  .title-audio {
    text-align: left;
    padding: 15px;
    font-size: 18px;
    font-weight: 600;
    border-top: 4px solid #49804c;
    .v-icon {
      border: 2px solid #49804c;
      color: #49804c;
      margin-right: 16px;
      width: 30px;
      height: 30px;
    }
  }
  .title-video {
    text-align: left;
    padding: 15px;
    font-size: 18px;
    font-weight: 600;
    border-top: 4px solid #8c5ea7;
    .v-icon {
      color: #fff;
      background-color: #8c5ea7;
      margin-right: 16px;
      width: 30px;
      height: 30px;
    }
  }
}

.v-breadcrumbs {
  padding-left: 0px !important;
  li {
    .v-breadcrumbs__item {
      font-size: 10.5px;
    }
  }
}
</style>
